import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

const HIDDEN_ON = ["/", "/entrer", "/atelier", "/radio", "/radio/naissance"];
const HIDDEN_PREFIXES = ["/duo/", "/cercle/"];

export function BackButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const hidden = HIDDEN_ON.includes(pathname) || HIDDEN_PREFIXES.some((p) => pathname.startsWith(p));

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.button
          key="back-btn"
          onClick={handleBack}
          data-testid="global-back-btn"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          className="fixed bottom-6 left-4 sm:left-6 z-[60] glass rounded-full pl-3 pr-4 py-2.5 flex items-center gap-2 text-foreground/80 hover:text-primary transition-colors shadow-lg"
          aria-label={t("nav.back")}
        >
          <ArrowLeft size={18} className="text-primary" />
          <span className="text-sm font-medium">{t("nav.back")}</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
